/*
  Galerie produit « split » (≥ 990 px) — MyFootify.
  - Hauteur : le grand cadre et la colonne descendent jusqu'au bas des boutons de flocage
    (à défaut, des boutons de taille), sans jamais être moins hauts que le carré.
  - Clic sur une photo de la colonne : elle s'affiche dans le grand cadre et devient la photo
    active (encadrée). Clic sur le grand cadre : zoom Dawn sur la photo active.
  - Souris : on peut faire glisser la colonne ; un glissement n'est jamais pris pour un clic.
  La photo active reste celle de Dawn (.is-active) : un changement de variante met donc aussi
  le grand cadre à jour. Sous 990 px, rien de tout cela ne s'applique.
*/
(function () {
  if (window.mfSplitGallery) return;
  window.mfSplitGallery = true;

  var ecranLarge = window.matchMedia('(min-width: 990px)');
  var SEUIL_GLISSE = 5;

  function initialiser(produit) {
    if (!produit || produit.dataset.splitPret) return;
    var galerie = produit.querySelector('media-gallery');
    var cadre = galerie && galerie.querySelector('[data-split-stage]');
    var liste = galerie && galerie.querySelector('.product__media-list');
    if (!cadre || !liste) return;
    produit.dataset.splitPret = 'true';

    var imageCadre = cadre.querySelector('img');
    var boutonZoom = cadre.querySelector('[data-split-zoom]');

    function photoActive() {
      return liste.querySelector('.product__media-item.is-active') || liste.querySelector('.product__media-item');
    }

    /* ---------- grand cadre ---------- */
    /* Le cadre prend la couleur du fond de la photo (relevée dans un coin) : une photo en
       paysage paraît alors occuper toute la hauteur, sans rogner le produit. Photo transparente
       ou lecture impossible : le cadre reste blanc. */
    function teinter(src) {
      if (!src) return;
      var url;
      try { url = new URL(src, location.href); url.searchParams.set('width', '64'); } catch (e) { return; }
      var echantillon = new Image();
      echantillon.crossOrigin = 'anonymous';
      echantillon.onload = function () {
        try {
          var toile = document.createElement('canvas');
          toile.width = echantillon.naturalWidth; toile.height = echantillon.naturalHeight;
          var ctx = toile.getContext('2d');
          ctx.drawImage(echantillon, 0, 0);
          var a = ctx.getImageData(1, 1, 1, 1).data;
          var b = ctx.getImageData(toile.width - 2, 1, 1, 1).data;
          if (a[3] < 250 || b[3] < 250) { cadre.style.backgroundColor = ''; return; }
          cadre.style.backgroundColor = 'rgb(' + Math.round((a[0] + b[0]) / 2) + ',' + Math.round((a[1] + b[1]) / 2) + ',' + Math.round((a[2] + b[2]) / 2) + ')';
        } catch (e) { cadre.style.backgroundColor = ''; }
      };
      echantillon.src = url.toString();
    }

    function afficher(item) {
      var source = item && item.querySelector('.product__media img');
      if (!source || !imageCadre || imageCadre.dataset.mediaId === item.dataset.mediaId) return;
      imageCadre.dataset.mediaId = item.dataset.mediaId;
      if (source.srcset) imageCadre.srcset = source.srcset;
      imageCadre.src = source.currentSrc || source.src;
      imageCadre.alt = source.alt || '';
      teinter(source.currentSrc || source.src);
    }

    function choisir(item) {
      liste.querySelectorAll('.product__media-item.is-active').forEach(function (element) {
        if (element !== item) element.classList.remove('is-active');
      });
      item.classList.add('is-active');
      afficher(item);
      /* Garde les miniatures (affichées sur tablette) d'accord avec la photo choisie. */
      var miniatures = galerie.elements && galerie.elements.thumbnails;
      var miniature = miniatures && miniatures.querySelector('[data-target="' + item.dataset.mediaId + '"]');
      if (miniature && typeof galerie.setActiveThumbnail === 'function') galerie.setActiveThumbnail(miniature);
    }

    /* Changement de variante (Dawn déplace .is-active et remonte la photo en tête). */
    new MutationObserver(function () {
      afficher(photoActive());
    }).observe(liste, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    afficher(photoActive());

    boutonZoom.addEventListener('click', function () {
      var item = photoActive();
      var bouton = item && item.querySelector('.product__media-toggle');
      var ouvreur = bouton && bouton.closest('modal-opener');
      var fenetre = ouvreur && document.querySelector(ouvreur.getAttribute('data-modal'));
      if (fenetre && typeof fenetre.show === 'function') fenetre.show(bouton);
    });

    /* ---------- glisser à la souris ---------- */
    var depart = null;
    var aGlisse = false;

    liste.addEventListener('pointerdown', function (event) {
      if (!ecranLarge.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
      /* Un clic sur la barre de défilement garde son comportement natif. */
      if (event.clientX - liste.getBoundingClientRect().left > liste.clientWidth) return;
      depart = { y: event.clientY, haut: liste.scrollTop, id: event.pointerId };
      aGlisse = false;
    });
    liste.addEventListener('pointermove', function (event) {
      if (!depart || event.pointerId !== depart.id) return;
      var ecart = event.clientY - depart.y;
      if (!aGlisse && Math.abs(ecart) > SEUIL_GLISSE) {
        aGlisse = true;
        liste.classList.add('is-dragging');
        try { liste.setPointerCapture(event.pointerId); } catch (erreur) {}
      }
      if (aGlisse) {
        liste.scrollTop = depart.haut - ecart;
        event.preventDefault();
      }
    });
    function finGlisse() {
      if (!depart) return;
      depart = null;
      liste.classList.remove('is-dragging');
      /* Le clic qui suit un glissement arrive juste après : on l'ignore, puis on réarme. */
      if (aGlisse) setTimeout(function () { aGlisse = false; }, 0);
    }
    liste.addEventListener('pointerup', finGlisse);
    liste.addEventListener('pointercancel', finGlisse);
    liste.addEventListener('dragstart', function (event) {
      if (ecranLarge.matches) event.preventDefault();
    });

    /* ---------- clic dans la colonne : afficher, pas zoomer ---------- */
    liste.addEventListener('click', function (event) {
      if (!ecranLarge.matches) return;
      if (aGlisse) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var item = event.target.closest('.product__media-item');
      if (!item || !liste.contains(item)) return;
      event.preventDefault();
      event.stopPropagation();
      choisir(item);
    }, true);

    /* ---------- hauteur : jusqu'au bas des boutons de flocage ---------- */
    var enAttente = false;
    function mesurer() {
      enAttente = false;
      if (!ecranLarge.matches) {
        produit.style.removeProperty('--split-h');
        return;
      }
      var info = produit.querySelector('.product__info-container');
      var repere = info && (info.querySelector('.mflo__onglets') || info.querySelector('.product-form__input--pill'));
      var carre = cadre.getBoundingClientRect().width;
      var hauteur = carre;
      if (repere) {
        /* Galerie et infos sont « sticky » : on les remet en place normale le temps de la mesure
           (même tâche, donc rien n'est affiché entre-temps), pour mesurer hors défilement. */
        var positions = [info.style.position, galerie.style.position];
        info.style.position = 'static';
        galerie.style.position = 'static';
        hauteur = Math.max(carre, repere.getBoundingClientRect().bottom - cadre.getBoundingClientRect().top);
        info.style.position = positions[0];
        galerie.style.position = positions[1];
      }
      var valeur = Math.round(hauteur) + 'px';
      if (produit.style.getPropertyValue('--split-h') !== valeur) produit.style.setProperty('--split-h', valeur);
    }
    function planifier() {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(mesurer);
    }

    if (window.ResizeObserver) {
      var observateur = new ResizeObserver(planifier);
      var info = produit.querySelector('.product__info-container');
      if (info) observateur.observe(info);
      observateur.observe(produit.querySelector('.product__media-wrapper') || galerie);
    }
    window.addEventListener('resize', planifier);
    window.addEventListener('load', planifier);
    if (ecranLarge.addEventListener) ecranLarge.addEventListener('change', planifier);
    mesurer();
  }

  function tout() {
    document.querySelectorAll('.product--split').forEach(initialiser);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  document.addEventListener('shopify:section:load', tout);
})();
